import React from 'react';
import './AboutSection.css';

const AboutSection = () => {
  return (
    <section id="about" className="about-section">
      {/* Top Section - Image Background with Who We Are Box */}
      <div className="about-top">
        <div className="about-top-container">
          <div className="about-top-content">
            <div className="who-we-are-box">
              <h3 className="who-we-are-title">Who We Are</h3>
              <p className="who-we-are-description">
                We are a team of skilled professionals, including designers, developers, and strategists, committed to enhancing business growth through innovative digital solutions. With a focus on delivering user-centric experiences, we ensure excellence and measurable results across a wide range of industries.
              </p>
              <button className="more-about-btn">More About Us</button>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Section - White Background with Text and Statistics */}
      <div className="about-bottom">
        <div className="about-bottom-container">
          <div className="about-bottom-content">
            <h2 className="about-title">Bring Your Ideas to life</h2>
            <p className="about-description">
              From startups to established enterprises, we partner with businesses across industries to create exceptional digital experiences.
            </p>
            <div className="about-stats">
              <div className="stat-item">
                <div className="stat-number">3+</div>
                <div className="stat-label">Years of Experience</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">12</div>
                <div className="stat-label">Project Done</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">8</div>
                <div className="stat-label">Passionate In-house Experts</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">10</div>
                <div className="stat-label">Satisfied Clients</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection; 